"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var TorihikisakiSekininsyaTanto = /** @class */ (function (_super) {
    __extends(TorihikisakiSekininsyaTanto, _super);
    function TorihikisakiSekininsyaTanto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.showConfirmDialog = false;
        _this.salesForceInfo = {
            torihikisakiId: '',
            tantoTorihikisakiId: '',
        };
        return _this;
    }
    TorihikisakiSekininsyaTanto.prototype.refs = function () {
        return this.$refs;
    };
    TorihikisakiSekininsyaTanto.prototype.reCorrect = function () {
        this.$emit('re-correct');
    };
    TorihikisakiSekininsyaTanto.prototype.csvOutput = function () {
        this.$emit('csv-output', ReflectType_1.SalesForceReflectType.SEKININSYA_TANTO);
    };
    TorihikisakiSekininsyaTanto.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    TorihikisakiSekininsyaTanto.prototype.initDataChange = function () {
        this.form = this.initData;
    };
    TorihikisakiSekininsyaTanto.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
    };
    TorihikisakiSekininsyaTanto.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        event.preventDefault();
                        if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                            this.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        if (!value_checker_1.default.isBlank(self_.salesForceInfo.tantoTorihikisakiId)) return [3 /*break*/, 1];
                        this.confirmMessage = '取引先責任者オブジェクト（担当者）を<strong>新規に追加</strong>します。よろしいですか？';
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.fetchSalesForceInfo(self_.getAjaxInfo())];
                    case 2:
                        result = _a.sent();
                        if (!Object.keys(result).length) {
                            return [2 /*return*/];
                        }
                        this.confirmMessage = '<div class="col">以下の取引先責任者オブジェクト（担当者）を<strong>上書き</strong>します。よろしいですか？<br>' +
                            ("\u6CD5\u4EBA\u540D: <strong>" + result['companyName'] + "</strong><br>") +
                            ("\u540D\u524D: <strong>" + result['name'] + "</strong><br>") +
                            ("\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9: <strong>" + result['email'] + "</strong><br>") +
                            "</div>";
                        _a.label = 3;
                    case 3:
                        this.showConfirmDialog = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    TorihikisakiSekininsyaTanto.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    TorihikisakiSekininsyaTanto.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    TorihikisakiSekininsyaTanto.prototype.getAjaxInfo = function () {
        return {
            salesForceInfo: {
                corporateId: this.salesForceInfo.corporateId.trim(),
                tantoTorihikisakiId: this.salesForceInfo.tantoTorihikisakiId.trim()
            },
            reflectType: [ReflectType_1.SalesForceReflectType.SEKININSYA_TANTO],
            fetchTypes: [ReflectType_1.SalesForceReflectType.SEKININSYA_TANTO, ReflectType_1.SalesForceReflectType.TORIHIKISAKI]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], TorihikisakiSekininsyaTanto.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], TorihikisakiSekininsyaTanto.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], TorihikisakiSekininsyaTanto.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], TorihikisakiSekininsyaTanto.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], TorihikisakiSekininsyaTanto.prototype, "initSalesForceDataChange", null);
    TorihikisakiSekininsyaTanto = __decorate([
        vue_property_decorator_1.Component({
            components: {
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                SimpleDialog: SimpleDialog_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], TorihikisakiSekininsyaTanto);
    return TorihikisakiSekininsyaTanto;
}(vue_property_decorator_1.Vue));
exports.default = TorihikisakiSekininsyaTanto;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/TorihikisakiSekininsyaTanto.vue
// module id = hGiF
// module chunks = 1